import { VerifStatusEnum } from '@/lib/enum';
import { isCertified } from '@/lib/utils';
import { BadgeCheck } from 'lucide-react';

type TProps = {
  forceDisplay?: boolean;
  size?: string | number;
  className?: string;
  user?: {
    verifications?: {
      id?: {
        status: VerifStatusEnum;
      };
    };
  };
}

const BadgeUserCertified = ({ user, className, forceDisplay, size = 20 }: TProps) => {

  if (!forceDisplay && !isCertified(user?.verifications)) {
    return <></>;
  }

  return (
    <BadgeCheck
      size={size}
      fill='#22c55e'
      color='white'
      className={className} />
  );

};

export default BadgeUserCertified;
